import { Injectable, Input } from "@angular/core";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie";
import { firstValueFrom } from "rxjs";
import { NotificationService } from "./notification.service";
import { UserService } from "./user.service";

const TOKEN_KEY = "auth-token";
const USER_KEY = "auth-user";
const USER_ID = "auth_user_id";
const PENDING_2FA_KEY = "pending2FAEnrollment";

@Injectable({
  providedIn: "root",
})
export class TokenStorageService {
  constructor(
    private cookieservice: CookieService,
    private userService: UserService,
    private _router: Router,
    private _notificationSvc: NotificationService
  ) {}

  timeoutID: any;

  dataUserForm = {
    nombre: "",
    apellido1: "",
    apellido2: "",
    id: "",
    email: "",
    tfa: "",
    "2faEnabled": "",
    rol: "",
    representados: [],
    esRepresentado: [],
    numero_documento: "",
    tipo_documento: "",
    tipopersona: "",
    telefono: "",
    direcciones: [],
    titulacion: "",
    fechaNacimiento: "",
    genero: "",
    email_confirmado: "",
    usuarioRepresenta: ""
  };
  signOut(): void {
    window.sessionStorage.clear();
  }

  public saveToken(token: string): void {
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.setItem(TOKEN_KEY, token);

    //this.setExpitationTimeout();
  }

  public getToken(): string | null {
    return window.sessionStorage.getItem(TOKEN_KEY);
  }

  setPending2FAEnrollment(pending: boolean): void {
    if (pending) {
      window.sessionStorage.setItem(PENDING_2FA_KEY, 'true');
    } else {
      window.sessionStorage.removeItem(PENDING_2FA_KEY);
    }
  }

  isPending2FAEnrollment(): boolean {
    return window.sessionStorage.getItem(PENDING_2FA_KEY) === 'true';
  }

  public getId(): string | null {
    return window.sessionStorage.getItem(USER_ID).replace(/["]/g, "");
  }

  public setUser(user, userRepresenta?): void {
    
    window.sessionStorage.setItem(USER_ID, user.id);
    window.sessionStorage.setItem(
      USER_KEY,
      JSON.stringify(this.buildDataUser(user, {}, userRepresenta))
    );
  }

  public saveUser(): void {
    window.sessionStorage.removeItem(USER_KEY);
    firstValueFrom(this.userService.getCurrentUserRepresented()).then(
      (dataRepresented) => {
        firstValueFrom(this.userService.getCurrentUserFromServer()).then(
          (dataUser) => {
           
            this.buildDataUser(dataUser.Usuario, dataRepresented, dataUser.usuarioRepresenta);
            window.sessionStorage.setItem(USER_ID, dataUser.Usuario.id);
            window.sessionStorage.setItem(
              USER_KEY,
              JSON.stringify(this.dataUserForm)
            );
          }
        );
      }
    );
  }

  buildDataUser(dataUser, dataRepresented, usuarioRepresenta?) {


    this.dataUserForm.id = dataUser.id;
    this.dataUserForm.nombre = dataUser.nombre;
    this.dataUserForm.apellido1 = dataUser.apellido1;
    this.dataUserForm.apellido2 = dataUser.apellido2;
    this.dataUserForm.tfa =
      dataUser.twoFactorSecret != null ? dataUser.twoFactorSecret : "disabled";
    this.dataUserForm.email = dataUser.email;
    this.dataUserForm.titulacion = dataUser.titulacion;
    this.dataUserForm.fechaNacimiento = dataUser.fechaNacimiento;
    this.dataUserForm.genero = dataUser.genero;
    this.dataUserForm.email_confirmado = dataUser.email_confirmado;

    this.dataUserForm["2faEnabled"] = dataUser.twoFactorEnabled;
    this.dataUserForm.rol = dataUser.rol.map((item) => item.id);
    this.dataUserForm.representados = dataUser.representados;
    this.dataUserForm.numero_documento = dataUser.numero_documento;
    this.dataUserForm.tipo_documento = dataUser.tipo_documento;
    this.dataUserForm.tipopersona = dataUser.tipopersona;
    this.dataUserForm.telefono = dataUser.telefono;
    this.dataUserForm.direcciones = dataUser.direcciones;
    this.dataUserForm.representados = dataRepresented.representa
      ? ""
      : dataRepresented.representa;
    this.dataUserForm.esRepresentado = dataRepresented.representado_por
      ? ""
      : dataRepresented.representado_por;
    this.dataUserForm.usuarioRepresenta = usuarioRepresenta;
    return this.dataUserForm;
  }

  public getUser(): any {
    const user = window.sessionStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }
    return {};
  }

  setExpitationTimeout() {
    clearTimeout(this.timeoutID);
    this.timeoutID = setTimeout(() => {
      this.signOutExpirationAndRedirectTo("/");
    }, 45 * 60000);
  }

  signOutExpirationAndRedirectTo(path, queryParams?): void {
    window.sessionStorage.clear();
    this._router
      .navigate([path], { queryParams: queryParams, replaceUrl: true })
      .then(() => {
        window.location.reload();
        this._notificationSvc.warning(
          "Ha expirado su sesión",
          "Su sesión ha expirado por inactividad, debe volver a logearse para continuar",
          50000
        );
      });
  }
}
